const userCategory = {
    Individual: 1,
    Business: 2,
    Vendor:3,
    Client: 4,
};

export default userCategory;